import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/ContactsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { getData as getClients } from '../../../models/ClientsModel';
import { DatePicker, MyReactSelect, Text, TextEmail, TextNumber } from '../../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { QuickAdd } from '../../modals/QuickAdd';
import AdminLayout from "../../layout/AdminLayout";
import PageHeader from "../../common/PageHeader";
import { Helmet } from "react-helmet";
export default function ContactAddForm () {

    const location = useLocation();
    const module = {
        title: 'Add POC',
        singularTitle: 'POC',
        key: 'contacts',
        route: 'contacts',
        primaryCol: '_contact_id',
    };

  const inputFields = {
    contact_name: '',
    contact_client_id: '',
    contact_mobile: '',
    contact_email: '',
    contact_designation: '',
    contact_skills: '',
    contact_last_contacted: '',
    contact_meeting_mom: '',
  }
  const formatOptions = [
    {
      type: 'react-select',
      column: 'contact_client_id',
      labelColumn: 'client_name'
    },
    {
      type: 'react-datepicker',
      column: 'contact_last_contacted',
    }
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const [clients, setClients] = useState([]);
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});

        const clientOptions = result.clients.map(client => ({
          value: client._client_id,
          label: client.client_name
        }));

        setClients(clientOptions);
      } catch (error) {
        console.error(error);
      }
    };

    fetchClients();
  }, []);

//   const closeModal = () =>{
//     setId('');
//     setFields(inputFields);
//     setErrors({});

//     setShowModal(false);
//   }

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  // Fetch the contact data when the component loads
  
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);

      let response;
    //   if (data) {
        //response = await model.update(user_data.user_token, id, formData);
    //   } else {
        response = await model.create(user_data.user_token, formData);
    //   }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        // closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        navigate("/contacts");
        // refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  return (
    <>
    <AdminLayout>
    <Helmet>
        <title>{module.title} - Digital CMS</title>
      </Helmet>
      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell">
        <PageHeader module={module}  />
        {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="card-body">
                            <form onSubmit={submit}>
                            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="contact_name" label="POC Name" required={true} fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <MyReactSelect column="contact_client_id" label="Client" options={clients} required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules="required" quickAddKey="clients" quickAddSet={setQuickModals} />
              </div>
              
              <div className="col-xl-4">
                <TextNumber column="contact_mobile" label="Contact Number" required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules="min:10|max:10" />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <TextEmail column="contact_email" label="Email" required={true} fields={fields} setFields={setFields} errors={errors} validator={validator} rules='email' />
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_designation" label="Designation" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_skills" label="LOB/Skills/Departments Managed" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <div className="form-input">
                  <DatePicker column="contact_last_contacted" label="Last Contacted" fields={fields} setFields={setFields} errors={errors} pluginProps={{maxDate: new Date()}} />
                </div>
              </div>
              
              <div className="col-xl-4">
                <Text column="contact_meeting_mom" label="MoM of the meeting" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>
            
                      <button type="submit" className="btn btn-primary" disabled={loading} >
                        {loading ? "Submitting..." : "Submit Contact"}
                      </button>

            
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </div>
        </div>
    </AdminLayout>
    </>
  );
};
